// extracted by mini-css-extract-plugin
export default {"flex":"Admin_flex__T81bU","desktopSideMenu":"Admin_desktopSideMenu__1Lfyx","bottomSideMenu":"Admin_bottomSideMenu__Z+++k"};